import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'userwallet';
const Invoice_API_URL = environment.apiUrl + 'user-invoice';
@Injectable({
    providedIn: 'root'
})
export class UserWalletService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getUserWalletList(query): Observable<any> {
        return this.http.get(API_URL + query,this.httpOptions);
    }
    getUserWalletDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id,this.httpOptions);
    }
    updateUserWallet(id, userdata): Observable<any> {
        return this.http.put(API_URL + '/' + id, userdata,this.httpOptions);
    }
    addUserWallet(walletdata): Observable<any> {
        return this.http.post(API_URL, walletdata,this.httpOptions);
    }
    addUserInvoice(userInvoiceData): Observable<any> {
        return this.http.post(environment.apiUrl+"user-invoice", userInvoiceData);
      }
   getUserNotificationList(query): Observable<any> {
        return this.http.get(environment.apiUrl+"user-notification" + query,this.httpOptions);
    }
    getContestUserTDSreport(query): Observable<any> {
        return this.http.get(API_URL+ "/contestUserTDSreport"+ query,this.httpOptions);
    }
    updateReadFlag(id, userdata): Observable<any> {
        //return this.http.get(environment.apiUrl+"user-notification" + query,this.httpOptions);

        return this.http.put(environment.apiUrl+"user-notification/" + id, userdata,this.httpOptions);
    }

    getUserWalletListCommission(query): Observable<any> {
        return this.http.get(API_URL + "/commission" + query,this.httpOptions);
    }
    getUserPaymentDetails(query): Observable<any> {
        return this.http.get(API_URL + "/paymentdetails" + query,this.httpOptions);
    }
     getUserInvoiceList(query): Observable<any> {
        return this.http.get(Invoice_API_URL+'/showall' + query,this.httpOptions);
    }
    generateAccountsReport(query:string) {
        return this.http.get(API_URL + "/report/csv" + query);
    }

    getUserWalletReportList(query:string) {
        return this.http.get(API_URL + "/cashBalanceSummary" + query);
    }
}